export type TrackPayload = Record<string, string | number | boolean | undefined>;

/**
 * Light funnel instrumentation. No-ops unless a host analytics bridge exists
 * (GTM dataLayer and/or Plausible). Never throws into product UI.
 */
export default function trackEvent(name: string, payload?: TrackPayload): void {
  if (typeof window === 'undefined') return;

  try {
    const w = window as Window & {
      dataLayer?: Array<Record<string, unknown>>;
      plausible?: (event: string, opts?: { props?: TrackPayload }) => void;
    };

    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({ event: name, ...(payload || {}) });
    }

    if (typeof w.plausible === 'function') {
      w.plausible(name, payload ? { props: payload } : undefined);
    }
  } catch {
    // Ignore analytics failures
  }
}



// WEBPACK FOOTER //
// ./src/utils/trackEvent.ts